import { render } from "./Cabecera.vue?vue&type=template&id=23a36a7e"
import script from "./Cabecera.vue?vue&type=script&lang=js"
export * from "./Cabecera.vue?vue&type=script&lang=js"

import "./Cabecera.vue?vue&type=style&index=0&id=23a36a7e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__